module.exports = __webpack_public_path__ + "static/media/c1_levels_8-29.c0f97730.png";